import { ref } from "vue";
import axiosInstance from "../config/axiosConfig.js";
import { useToast } from "vue-toastification";
import { useRouter } from "vue-router";
import sessionManager from "../utils/sessionManager.js";

class PaymentService {
  constructor() {
    this.success = ref(false);
    this.message = ref("");
    this.errors = ref({});
    this.paymentGatewayChannelList = ref([]);
    this.journeyData = ref({});
    this.paymentStatus = ref({});
    this.paymentReference = ref("");

    this.toast = useToast();
    this.router = useRouter();
  }

  async getPaymentGatewayChannels() {
    try {
      const response = await axiosInstance.get(`/payments/channels`);
      this.paymentGatewayChannelList.value = response.data;
    } catch (e) {
      if (e.response && e.response.status === 422) {
        this.errors.value = e.response.data.errors;
      } else if (e.response && e.response.status === 401) {
        this.toast.error("Session expired.");
        this.router.replace({ path: "/" });
      }
    }
  }

  async makePayment(data) {
    try {
      const response = await axiosInstance.post(`/payments/checkout`, data);
      this.success.value = response.data.success;
      this.message.value = response.data.message;
      const payRef = response.data.data?.payment_reference ?? "";
      this.paymentReference.value = payRef;
      if (payRef) {
        sessionManager.storePaymentReference(payRef);
      }
    } catch (e) {
      this.success.value = false;
      if (e.response && e.response.status === 422) {
        this.errors.value = e.response.data.errors;
        this.message.value = Object.values(e.response.data.errors).flat().join(", ");
      } else if (e.response && e.response.status === 401) {
        this.toast.error("Session expired.");
        this.router.replace({ path: "/" });
      } else {
        this.message.value = e.response?.data?.message ?? "Payment failed";
      }
    }
  }

  async checkPaymentStatus() {
    try {
      const paymentReference = sessionManager.getPaymentReference();
      const response = await axiosInstance.get(`/payments/booking-status`, {
        params: { payment_reference: paymentReference },
      });
      const data = response.data.data ?? response.data;
      this.paymentStatus.value = {
        success: data.all_paid === true,
        message: data.message ?? (data.all_paid ? "Paid" : "Pending"),
        all_paid: data.all_paid,
      };
    } catch (e) {
      this.paymentStatus.value = {
        success: false,
        message: "Could not check payment status.",
      };
      if (e.response && e.response.status === 401) {
        this.toast.error("Session expired.");
        this.router.replace({ path: "/" });
      }
    }
  }
}

export default PaymentService;
